import './../styles/fleet-offer/fleet-offer.scss';
import contactForm from './fleet-offer/contact';
import sidepanel from './become-partner/sidepanel';

export default {
  init() {
    console.log('oferta flotowa');
    contactForm();
    sidepanel();
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  }
};
